export default {
    environment: 'production',
    appHostname: 'practitioner.luminalearning.com',
    ssoV1Hostname: 'sso.luminalearning.com',
    ssoV2Hostname: 'sso.v2.luminalearning.com',
    financeHostname: 'finance.luminalearning.com',
    graphqlGatewayHostname: 'graphql.api.luminalearning.com',
    luminaOnlineHostname: 'www.luminalearning.com',
    luminaOpenBadgesClientHostname: 'badges.luminalearning.com',
    luminaGetQualifiedUrlHostname: 'luminalearning.com/become-a-practitioner/',
    teamsHostname: 'team.luminalearning.com',
    AtsHostname: 'ats.luminalearning.com',
    eLearningHostname: 'e-learning.luminalearning.com',
    openApiHostname: 'api2.luminalearning.com',
    keycloakServerUrl: 'auth.luminalearning.com',
    participantProjectPaginationLimit: 10,
    projectAndSearchPaginationLimit: 20,
    forceHttps: true,
};
